import { useState } from 'react';
import { EChallengesType, EPillar, IChallenges } from '../../types/challenges';
import Edit from './components/Edit';
import Show from './components/Show/Show';
import { useControll } from './useControll';

const ChallengesScreen = () => {
  const [selectedCategory, setSelectedCategory] = useState<EPillar | null>(null);
  const [openFilter, setOpenFilter] = useState(false);
  const [filterStatus, setFilterStatus] = useState<string>("");
  const [filterType, setFilterType] = useState<string>("");
  const [modalStatus, setModalStatus] = useState<string>("");
  const [modalType, setModalType] = useState<string>("");
  const [mode, setMode] = useState<'show' | 'edit'>('show');
  const [editMode, setEditMode] = useState<'create' | 'edit'>('create');
  const [selectedChallenge, setSelectedChallenge] = useState<IChallenges | null>(null);
  const {
    sortBy,
    sortDir,
    challenges,
    totalPages,
    searchValue,
    page,
    setSortBy,
    setSortDir,
    setSearchValue,
    setPage,
    challengeTotals,
    dataCards,
    totalElements,
    pageSize,
    loading,
    handleToggleStatus,
    handleDeleteChallenge,
    refreshChallenges,
  } = useControll({ selectedCategory, filterStatus, filterType });

  const handleSort = (key: string) => {
    const typedKey = key as keyof IChallenges;
    if (sortBy === typedKey) {
      setSortDir(sortDir === 'asc' ? 'desc' : 'asc');
    } else {
      setSortBy(typedKey);
      setSortDir('asc');
    }
  };

  const handlePageChange = (newPage: number) => {
    if (newPage < 1 || newPage > totalPages) return;
    setPage(newPage);
  };

  const handleSearchChange = (v: string) => {
    setSearchValue(v);
  };

  const handleCardClick = (pillar: EPillar) => {
    setSelectedCategory(pillar === selectedCategory ? null : pillar);
    setPage(1);
  };

  // Tipos únicos para o filtro
  const uniqueTypes = Array.from(new Set(challenges.map((c: IChallenges) => c.type).filter(Boolean)));

  return mode === 'show' ? (
    <Show
      pageSize={pageSize}
      dataCards={dataCards}
      selectedCategory={selectedCategory}
      onCardClick={handleCardClick}
      searchValue={searchValue}
      onSearchChange={handleSearchChange}
      onOpenFilter={() => {
        setModalStatus(filterStatus);
        setModalType(filterType);
        setOpenFilter(true);
      }}
      challenges={challenges}
      page={page}
      totalPages={totalPages}
      totalElements={totalElements}
      loading={loading}
      onPageChange={handlePageChange}
      sortBy={sortBy}
      sortDir={sortDir}
      onSort={handleSort}
      challengeTotals={challengeTotals}
      uniqueTypes={uniqueTypes as string[]}
      filterStatus={filterStatus}
      filterType={filterType}
      modalStatus={modalStatus}
      modalType={modalType}
      setModalStatus={setModalStatus}
      setModalType={setModalType}
      setOpenFilter={setOpenFilter}
      setFilterStatus={setFilterStatus}
      setFilterType={setFilterType}
      onCreateEdit={() => {
        setEditMode('create');
        setSelectedChallenge(null);
        setMode('edit');
      }}
      onEditChallenge={challenge => {
        if (challenge.type !== EChallengesType.PERSONALIZED) {
          return;
        }
        setEditMode('edit');
        setSelectedChallenge(challenge);
        setMode('edit');
      }}
      onToggleStatus={handleToggleStatus}
      onDelete={handleDeleteChallenge}
    />
  ) : (
    <Edit
      mode={editMode}
      challenge={selectedChallenge || undefined}
      onBack={() => {
        setMode('show');
        setSelectedChallenge(null);
        refreshChallenges();
      }}
    />
  );
};

export default ChallengesScreen;
